import Vue from 'vue'
import Vant, { Button } from 'vant'
import '@/assets/scss/vant.scss'
import _ from 'lodash'

/**
 * 在表单中，除了提交按钮外，可能还有一些其他的功能性按钮，如发送验证码按钮。在使用这些按钮时，要注意将native-type设置为button，否则会触发表单提交。
 * <van-button native-type="button">发送验证码</van-button>
 * 这个问题的原因是浏览器中 button 标签 type 属性的默认值为submit，导致触发表单提交。我们会在下个大版本中将 type 的默认值调整为button来避免这个问题。
 */
const CustomButton = {
  ...Button,
  props: {
    ...Button.props,
    nativeType: {
      type: String,
      default: 'button'
    }
  }
}

export class SwipeAdapter {
  startPosition = null
  lastPosition = null
  moved = false
  eventArgs = null
  clickHandler = null

  constructor (swipe, clickHandler) {
    this.swipe = swipe
    this.vertical = swipe.vertical
    this.clickHandler = clickHandler
  }

  getMoved () {
    const direction = this.vertical ? 'y' : 'x'
    const last = _.get(this.lastPosition, direction) || 0
    const start = _.get(this.startPosition, direction) || 0
    return last - start
  }

  registerEvent () {
    window.addEventListener('mousemove', this._onMouseMove)
    window.addEventListener('mouseup', this._onMouseUp)
  }

  uninstallEvent () {
    window.removeEventListener('mousemove', this._onMouseMove)
    window.removeEventListener('mouseup', this._onMouseUp)
  }

  onMouseDown (e, ...args) {
    this.startPosition = {
      x: e.clientX,
      y: e.clientY,
      date: Date.now()
    }
    this.moved = false
    this.eventArgs = args
    this.registerEvent()
    this.swipe.clear()
    this.swipe.correctPosition()
  }

  _onMouseMove = (e) => {
    this.moved = true
    this.lastPosition = {
      x: e.clientX,
      y: e.clientY,
      date: Date.now()
    }
    const offset = this.getMoved()
    this.swipe.move({ offset })
  }

  _onMouseUp = (e) => {
    this.uninstallEvent()
    this.swipe.swiping = false
    this.swipe.autoPlay()
    if (!this.moved) {
      this._onClick(e)
      return
    }
    const moved = this.getMoved()
    const duration = this.lastPosition.date - this.startPosition.date
    const speed = moved / duration
    let pace = 0
    if (Math.abs(speed) > 0.25 || Math.abs(moved) > this.swipe.size / 2) {
      pace = moved > 0 ? -1 : 1
    }

    this.swipe.move({
      pace: pace,
      emitChange: pace !== 0
    })
  }

  _onClick (e) {
    if (!this.clickHandler) {
      return
    }
    const args = this.eventArgs || []
    return this.clickHandler(e, ...args)
  }
}

export function setup () {
  Vue.use(Vant)
  Vue.component(CustomButton.name, CustomButton)
}
